/*
 * action types
 */
export const BOOKMARK = 'BOOKMARK'

/*
 * action creators
 */
export default function setBookmark(payload) {
  return {
    payload,
    type: BOOKMARK,
  }
}
